import {create} from 'zustand'
import type {ChatUnreadSummary} from '@/types'

interface ChatUnreadState {
  unreadCount: number
  roomUnreadMap: Record<number, number>
  activeRoomId: number | null
  setUnreadCount: (count: number) => void
  setUnreadSummary: (summary: ChatUnreadSummary) => void
  setActiveRoomId: (roomId: number | null) => void
  reset: () => void
}

export const useChatUnreadStore = create<ChatUnreadState>((set) => ({
  unreadCount: 0,
  roomUnreadMap: {},
  activeRoomId: null,
  setUnreadCount: (count) =>
    set({
      unreadCount: Math.max(0, count),
      ...(count <= 0 ? {roomUnreadMap: {}} : {})
    }),
  setUnreadSummary: (summary) =>
    set((state) => {
      const rooms = summary.rooms.filter((room) => room.roomId !== state.activeRoomId)
      return {
        unreadCount: rooms.reduce((sum, room) => sum + Math.max(0, room.count), 0),
        roomUnreadMap: Object.fromEntries(rooms.map((room) => [room.roomId, Math.max(0, room.count)]))
      }
    }),
  setActiveRoomId: (roomId) =>
    set((state) => {
      if (!roomId) {
        return {activeRoomId: null}
      }

      const roomUnreadMap = {...state.roomUnreadMap}
      delete roomUnreadMap[roomId]
      return {
        activeRoomId: roomId,
        roomUnreadMap,
        unreadCount: Object.values(roomUnreadMap).reduce((sum, count) => sum + count, 0)
      }
    }),
  reset: () => set({unreadCount: 0, roomUnreadMap: {}, activeRoomId: null})
}))
